/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'emblazoned',
    quality: 0.4,
    learning: 1,
    mana: 1,
    willpower: 2
}